import {useState} from "react";

interface CFContentTextProps {
    description: string;
    composition: string;
    expedition: string;
}
export default function CFContentText({description, composition, expedition}: CFContentTextProps) {
    const currentLanguage = document.documentElement.lang;

    const [activeTab, setActiveTab] = useState(0);

    return(
        <div className={'cf-content-text'}>
            <div className={'headers'}>
                <button data-active={activeTab === 0 ? 'true' : 'false'} onClick={() => setActiveTab(0)}>
                    <span>Description</span>
                </button>
                <button data-active={activeTab === 1 ? 'true' : 'false'} onClick={() => setActiveTab(1)}>
                    <span>Composition</span>
                </button>
                <button data-active={activeTab === 2 ? 'true' : 'false'} onClick={() => setActiveTab(2)}>
                    <span>{currentLanguage === 'fr' ? 'Retour et expédition' : 'Return and shipping'}</span>
                </button>
            </div>
            <div className={'content'}>
                {activeTab === 0 && <p dangerouslySetInnerHTML={{__html: description}} />}
                {activeTab === 1 && <p dangerouslySetInnerHTML={{__html: composition}} />}
                {activeTab === 2 && <p dangerouslySetInnerHTML={{__html: expedition}} />}
            </div>
        </div>
    );
}